"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ChartAPI = _interopRequireDefault(require("../../services/tradingView/ChartAPI"));
var _jstimezonedetect = _interopRequireDefault(require("jstimezonedetect"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
var _path = _interopRequireDefault(require("../../helpers/path"));
var _config = _interopRequireDefault(require("../../config"));
var _wsHelper = require("../../helpers/wsHelper");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./TVChartComponent.css");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _tickerHelper = require("../../helpers/tickerHelper");
var _withCssVars = require("../Theme/withCssVars");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* global TradingView */
var tvChartClasses = (0, _cssClassesHelper.getBEMClasses)(['tv-chart']);

/* These items were either non-working or buggy within our TradingView implementation,
and should stay disabled until they are fixed or reassessed. */
var disabledFeatures = ['header_settings', 'control_bar', 'context_menus', 'header_symbol_search', 'header_compare', 'use_localstorage_for_settings', 'save_chart_properties_to_local_storage', 'show_chart_property_page', 'header_resolutions', 'go_to_date'];
var TVChartComponent = /*#__PURE__*/function (_React$Component) {
  function TVChartComponent() {
    var _this;
    _classCallCheck(this, TVChartComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TVChartComponent, [].concat(args));
    _defineProperty(_this, "script", function (location) {
      return new Promise(function (resolve, reject) {
        _this.scripts[location] = document.createElement('script');
        _this.scripts[location].src = (0, _path["default"])(location);
        _this.scripts[location].type = 'text/javascript';
        _this.scripts[location].async = true;
        _this.scripts[location].onerror = function () {
          return reject(new Error("Failed to load script at ".concat(location)));
        };
        _this.scripts[location].onload = resolve;
        document.body.appendChild(_this.scripts[location]);
      });
    });
    _defineProperty(_this, "createChart", function (dataFeed) {
      var _this$getOverrides = _this.getOverrides(),
        overrides = _this$getOverrides.overrides,
        studiesOverrides = _this$getOverrides.studiesOverrides;

      // const custom_css_url = this.props.theme === 'light' ? '' : '/vendor/tradingView/charting_library-dark-theme.css';
      var chartOptions = {
        theme: _this.props.theme,
        symbol: _this.props.selectedInstrument.Symbol,
        datafeed: dataFeed,
        library_path: (0, _path["default"])('/vendor/tradingView/'),
        autosize: true,
        interval: (0, _tickerHelper.convertTickerIntervalToTradingViewResolution)(_config["default"].TickerData.defaultInterval),
        container: 'trading-view-chart',
        container_id: 'trading-view-chart',
        loading_screen: {
          backgroundColor: _this.props.getCssVar('tv-chart__loading-screen-bg-color')
        },
        //custom_css_url: path(custom_css_url),
        overrides: overrides,
        studies_overrides: studiesOverrides
      };
      var localOverrides = _config["default"].TradingView || {};
      var disabled_features;
      if ('disabled_features' in localOverrides) {
        disabled_features = _toConsumableArray(new Set([].concat(disabledFeatures, _toConsumableArray(localOverrides.disabled_features))));
      } else {
        disabled_features = disabledFeatures;
      }
      var enabled_features = [];
      if ('enabled_features' in localOverrides) {
        enabled_features = localOverrides.enabled_features.filter(function (item) {
          return !disabledFeatures.includes(item);
        });
      }

      // For some reasons TradingView.onready is not fired, timeout is used as fallback to initialize chart after 1.5 sec
      _this.timeout = setTimeout(function () {
        _this.chart = new TradingView.widget(_objectSpread(_objectSpread(_objectSpread({}, chartOptions), localOverrides), {}, {
          disabled_features: disabled_features,
          enabled_features: enabled_features
        }));
        _this.chart.onChartReady(function () {
          _this.setState({
            chartInitialized: true
          });
        });
      }, 3000);
    });
    return _this;
  }
  _inherits(TVChartComponent, _React$Component);
  return _createClass(TVChartComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.initChart();
      if (prevProps.theme !== this.props.theme && this.chart) {
        var _this$getOverrides2 = this.getOverrides(),
          overrides = _this$getOverrides2.overrides,
          studiesOverrides = _this$getOverrides2.studiesOverrides;
        this.chart.changeTheme(this.props.theme);
        this.chart.applyOverrides(overrides);
        this.chart.applyStudiesOverrides(studiesOverrides);
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (!this.props.selectedInstrument.InstrumentId && nextProps.selectedInstrument.InstrumentId) {
        return true;
      }
      return !!window.TradingView && !!nextState && !!nextState.chartInitialized;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.scripts = {};
      this.script('/vendor/jquery-3.3.1.min.js').then(function () {
        return _this2.script('/vendor/tradingView/charting_library.standalone.js');
      }).then(function () {
        _this2.initChart();
      });
    }
  }, {
    key: "initChart",
    value: function initChart() {
      if (!this.props.selectedInstrument.InstrumentId) return;
      this.wsUri = (0, _wsHelper.getGateway)();
      var timezone = _jstimezonedetect["default"].determine().name();
      var currentTimezone = timezone ? timezone : _config["default"].TradingView.timezone;
      if (!this.chart) {
        if (!window.tvChartDataFeed) {
          window.tvChartDataFeed = new _ChartAPI["default"].UDFCompatibleDatafeed(this.wsUri, null, this.props.customGateway, currentTimezone, function (increment) {
            return (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(increment);
          });
        }
        this.createChart(window.tvChartDataFeed);
      } else {
        this.chart.setSymbol(this.props.selectedInstrument.Symbol, (0, _tickerHelper.convertTickerIntervalToTradingViewResolution)(_config["default"].TickerData.defaultInterval));
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
      if (this.chart) {
        try {
          this.chart.remove();
        } catch (e) {
          console.warn('silently handled chart error: ', e);
        }
        this.scripts['/vendor/tradingView/charting_library.standalone.js'].remove();
        this.scripts['/vendor/jquery-3.3.1.min.js'].remove();
      }
    }
  }, {
    key: "getOverrides",
    value: function getOverrides() {
      var getCssVar = this.props.getCssVar;
      var bgColor = getCssVar('tv-chart__bg-color');
      var gridColor = getCssVar('tv-chart__grid-color');
      var gridColorVertical = getCssVar('tv-chart__grid-vertical-color');
      var gridColorHorizontal = getCssVar('tv-chart__grid-horizontal-color');
      var scaleFontColor = getCssVar('tv-chart__scale-font-color');
      var scaleLineColor = getCssVar('tv-chart__scale-line-color');
      var scaleBgColor = getCssVar('tv-chart__scale-bg-color');
      var graphUpColor = getCssVar('tv-chart__graph-up-color');
      var graphDownColor = getCssVar('tv-chart__graph-down-color');
      var graphBorderUpColor = getCssVar('tv-chart__graph-border-up-color');
      var graphBorderDownColor = getCssVar('tv-chart__graph-border-down-color');
      var graphUpOpaqueColor = "rgba(".concat(getCssVar('pc__accent-additive'), ", .3)");
      var graphDownOpaqueColor = "rgba(".concat(getCssVar('pc__accent-subtractive'), ", .3)");
      var overrides = {
        'paneProperties.background': bgColor,
        'paneProperties.gridProperties.color': gridColor,
        'paneProperties.vertGridProperties.color': gridColorVertical,
        'paneProperties.horzGridProperties.color': gridColorHorizontal,
        'paneProperties.topMargin': 15,
        'paneProperties.bottomMargin': 25,
        'scalesProperties.textColor': scaleFontColor,
        'scalesProperties.lineColor': scaleLineColor,
        'scalesProperties.showLeftScale': false,
        'scalesProperties.showRightScale': true,
        'scalesProperties.backgroundColor': scaleBgColor,
        volumePaneSize: 'large',
        'mainSeriesProperties.candleStyle.upColor': graphUpColor,
        'mainSeriesProperties.candleStyle.downColor': graphDownColor,
        'mainSeriesProperties.candleStyle.borderUpColor': graphBorderUpColor,
        'mainSeriesProperties.candleStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.candleStyle.drawWick': true,
        'mainSeriesProperties.hollowCandleStyle.upColor': graphUpColor,
        'mainSeriesProperties.hollowCandleStyle.downColor': bgColor,
        'mainSeriesProperties.hollowCandleStyle.borderUpColor': graphBorderUpColor,
        'mainSeriesProperties.hollowCandleStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.hollowCandleStyle.drawWick': false,
        'mainSeriesProperties.haStyle.upColor': graphUpColor,
        'mainSeriesProperties.haStyle.downColor': graphDownColor,
        'mainSeriesProperties.haStyle.borderUpColor': graphBorderUpColor,
        'mainSeriesProperties.haStyle.borderDownColor': graphBorderDownColor,
        'mainSeriesProperties.haStyle.drawWick': false,
        'mainSeriesProperties.barStyle.upColor': graphUpColor,
        'mainSeriesProperties.barStyle.downColor': graphDownColor,
        'mainSeriesProperties.lineStyle.color': graphUpColor,
        'mainSeriesProperties.lineStyle.linewidth': '4',
        'mainSeriesProperties.areaStyle.color1': graphUpColor,
        'mainSeriesProperties.areaStyle.color2': graphUpOpaqueColor,
        'mainSeriesProperties.areaStyle.linecolor': graphUpColor,
        'mainSeriesProperties.baselineStyle.topFillColor1': graphUpOpaqueColor,
        'mainSeriesProperties.baselineStyle.topFillColor2': graphUpOpaqueColor,
        'mainSeriesProperties.baselineStyle.bottomFillColor1': graphDownOpaqueColor,
        'mainSeriesProperties.baselineStyle.bottomFillColor2': graphDownOpaqueColor,
        'mainSeriesProperties.baselineStyle.topLineColor': graphUpColor,
        'mainSeriesProperties.baselineStyle.bottomLineColor': graphDownColor
      };
      var studiesOverrides = {
        'volume.volume.color.0': graphDownOpaqueColor,
        'volume.volume.color.1': graphUpOpaqueColor
      };
      return {
        overrides: overrides,
        studiesOverrides: studiesOverrides
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: tvChartClasses('', {
          'with-depth-chart': _config["default"].TradingLayout.showDepthChart && window.innerHeight >= 1080
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "trading-view-chart",
        className: tvChartClasses('chart-container')
      }, /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null)));
    }
  }]);
}(_react["default"].Component);
TVChartComponent.propTypes = {
  selectedInstrument: _propTypes["default"].object,
  theme: _propTypes["default"].string.isRequired,
  getCssVar: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _withCssVars.withCssVars)(TVChartComponent);